import { cloneDeep } from 'lodash';
import mergeWith from 'lodash/mergeWith';

export default (accountId, range, comparedRange, properties) => {
    let newProperties = mergeWith(
        [
            {
                filters: {
                    exclude_language: ['und'],
                    exists_language: true
                }
            }
        ],
        cloneDeep(properties)
    );

    return { range, comparedRange, accountId, properties: newProperties };
};